import classNames from "classnames";

import Icon from "./Icon";

const HintBlock = ({
  colorClassName = "primary",
  iconClassName = "fa fa-info-circle",
  size = "md",
  ...props
}) => {
  const { children } = props;

  const paddingClassNames =
    size === "sm" ? ["padding-x-md", "padding-y-sm"] : ["padding-x-lg", "padding-y-md"];

  const containerClassName = classNames(
    "box",
    "margin-bottom-xs",
    "form-hint",
    ...paddingClassNames,
    `border-${colorClassName}`
  );

  iconClassName = classNames("form-hint-icon", `text-${colorClassName}`, iconClassName);

  return (
    <div className={containerClassName}>
      <Icon className={iconClassName} />
      <div className="form-hint-content">{children}</div>
    </div>
  );
};

export default HintBlock;
